import RealEstate from './RealEstate/components/RealEstate';
import KnowledgeBase from './KnowledgeBase/components/KnowledgeBase';
import Search from './Search/components/Search';
import Notifications from './NotificationBanner/components/Notifications';
import { DetailMap } from './RealEstate/components/DetailMap';
import SmartAppBanner from './SmartAppBanner/components/SmartAppBanner';
import Powermail from './Powermail/components/Powermail';
export default {
    KnowledgeBase,
    Search,
    Notifications,
    RealEstate,
    DetailMap,
    SmartAppBanner,
    Powermail,
};
